import React, { useState } from "react";
import { RiMovie2Line } from "react-icons/ri";
import { FiLogIn } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";

const StartPageRegister = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState([]);

  const handleSubmit = (event) => {
    event.preventDefault();

    const validationErrors = validateLoginForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      navigate("/startlogin");
    }
  };

  const validateLoginForm = () => {
    const errors = {};
    if (!username) {
      errors.username = "Username is required";
    }
    if (!email) {
      errors.email = "Email is required";
    }
    if (!password) {
      errors.password = "Password is required";
    }
    return errors;
  };
  return (
    <div className="w-full h-screen lg:h-full relative">
      <img
        src="/images/wallpaper.jpg"
        alt="start-page"
        className="w-full h-full object-cover z-auto"
      />
      <div className="w-full flex items-center -mt-20 md:mt-auto justify-center bg-gray-900/80 absolute top-0 left-0">
        <form onSubmit={handleSubmit} className="max-w-lg mx-auto">
          <div className="bg-gray-900/60 absolute top-0 left-0 w-full md:w-full h-full">
            <div className="container mx-auto px-2 flex-colo">
              <div className="w-full md:w-3/5 2xl:w-2/5 gap-4 flex-colo p-8 my-44 sm:p-14 bg-dry opacity-90 rounded-lg border border-border">
                <Link className="flex font-bold text-subMain text-6xl" to="/">
                  O{" "}
                  <span className="flex text-3xl text-white py-4">
                    scar'sTv
                    <RiMovie2Line color="red" />
                  </span>
                </Link>

                <input
                  label="FullName: "
                  placeholder="username"
                  type="text"
                  className="w-full text-sm h-9 lg:h-14 p-2 text-black border border-border rounded"
                  value={username}
                  onChange={(event) => setUsername(event.target.value)}
                />
                <p className="text-slate-200 pt-1 text-sm">{errors.username}</p>

                <input
                  label="Email: "
                  placeholder="email address"
                  id="email"
                  type="email"
                  className="w-full text-sm h-9 lg:h-14 p-2 text-black border border-border rounded"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                />
                <p className="text-slate-200 pt-1 text-sm">{errors.email}</p>

                <input
                  label="Password: "
                  placeholder="password"
                  id="password"
                  type="password"
                  className="w-full text-sm h-9 lg:h-14 p-2 text-black border border-border rounded"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                />
                <p className="text-slate-200 pt-1 text-sm">{errors.password}</p>

                <button
                  type="submit"
                  className="bg-subMain transitions lg:h-auto h-12 hover:bg-main flex-rows gap-4 text-white p-4 rounded-lg w-full"
                >
                  <FiLogIn /> Sign Up
                </button>
                <p className="text-center text-border">
                  Already have an account?{" "}
                  <Link
                    to="/startlogin"
                    className="text-text font-semibold ml-2"
                  >
                    Sign In
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default StartPageRegister;
